const controllerRegistry = new Map<string, ReturnType<typeof useModal>>();

const modalRegistry = shallowReactive(new Map<string, number>());

function getOrCreateModalController(id: string) {
    if (!controllerRegistry.has(id)) {
        controllerRegistry.set(id, useModal());
    }
    return controllerRegistry.get(id)!;
}

function registerModal(id: string) {
    const instance = getCurrentInstance();
    if (!instance) throw new Error('[ModalRegistry] no instance');

    const uid = instance.uid;

    if (!modalRegistry.has(id)) {
        modalRegistry.set(id, uid);
    }

    const allowMount = computed(() => modalRegistry.get(id) === uid);

    onUnmounted(() => {
        if (modalRegistry.get(id) === uid) modalRegistry.delete(id);
    });

    return { allowMount };
}

export { getOrCreateModalController, registerModal };
